module.exports = __webpack_public_path__ + "img/list1.7680d4f1.png";